import type { Connection } from "./relay.js";

export const GIT_PUSH_PATH = "/api/git/push";

export interface GitPushResult {
  pushed?: boolean;
  remote?: string;
  branch?: string;
}

export async function gitPush(conn: Connection): Promise<GitPushResult> {
  return conn.api<GitPushResult>("POST", GIT_PUSH_PATH);
}
